// fitment-checker.js v3.10 – preserves PDP (v3.8) and isolates Quick View rendering/formatting
(() => {
  const vehicleKey = localStorage.getItem("activeVehicle");
  if (!vehicleKey) {
    console.warn("❌ fitment-checker: no active vehicle selected");
    return;
  }

  // PDP rendering (unchanged from v3.8)
  const renderPDP = (fitments, container) => {
    if (!Array.isArray(fitments) || !container) return;

    const selected = vehicleKey.trim();
    const combos = fitments.map(s => s.trim());
    const hasUniversal = combos.includes("Universal");
    const hasMatch = combos.includes(selected);
    if (hasUniversal && !hasMatch) return;

    container.className = "product-form__inventory";
    container.style.marginTop = "0.5em";

    const iconWrapper = document.createElement("div");
    iconWrapper.className = "product-form__inventory-icon";

    const iconBase = document.createElement("div");
    iconBase.className = "product-form__inventory-icon-base";
    iconBase.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512" height="26" style="width:auto;">
        <path fill="#212121" d="M280 32c-13.3 0-24 10.7-24 24s10.7 24 24 24l57.7 0 16.4 30.3L256 192l-45.3-45.3c-12-12-28.3-18.7-45.3-18.7L64 128c-17.7 0-32 14.3-32 32l0 32 96 0c88.4 0 160 71.6 160 160c0 11-1.1 21.7-3.2 32l70.4 0c-2.1-10.3-3.2-21-3.2-32c0-52.2 25-98.6 63.7-127.8l15.4 28.6C402.4 276.3 384 312 384 352c0 70.7 57.3 128 128 128s128-57.3 128-128s-57.3-128-128-128c-13.5 0-26.5 2.1-38.7 6L418.2 128l61.8 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32l-20.4 0c-7.5 0-14.7 2.6-20.5 7.4L391.7 78.9l-14-26c-7-12.9-20.5-21-35.2-21L280 32zM462.7 311.2l28.2 52.2c6.3 11.7 20.9 16 32.5 9.7s16-20.9 9.7-32.5l-28.2-52.2c2.3-.3 4.7-.4 7.1-.4c35.3 0 64 28.7 64 64s-28.7 64-64 64s-64-28.7-64-64c0-15.5 5.5-29.7 14.7-40.8zM187.3 376c-9.5 23.5-32.5 40-59.3 40c-35.3 0-64-28.7-64-64s28.7-64 64-64c26.9 0 49.9 16.5 59.3 40l66.4 0C242.5 268.8 190.5 224 128 224C57.3 224 0 281.3 0 352s57.3 128 128 128c62.5 0 114.5-44.8 125.8-104l-66.4 0zM128 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"/>
      </svg>
    `;

    const iconStatus = document.createElement("div");
    iconStatus.className = `product-form__inventory-icon-status ${hasMatch ? "text-success" : "text-danger"}`;
    iconStatus.innerHTML = `
      <svg viewBox="0 0 448 512" class="icon" height="14">
        <path fill="#fff" d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/>
      </svg>
    `;

    iconWrapper.appendChild(iconBase);
    iconWrapper.appendChild(iconStatus);

    const text = document.createElement("div");
    text.className = "product-form__inventory-text h6";
    text.style.color = hasMatch ? "#008000" : "#b00020";
    text.style.marginTop = "0.4em";
    text.innerHTML = `This item <strong>${hasMatch ? "fits" : "does not fit"}</strong> ${selected.replace(/_/g, " ")}`;

    container.innerHTML = "";
    container.appendChild(iconWrapper);
    container.appendChild(text);
  };

  // QUICK VIEW: Separate structure and formatting
  const renderQuickView = (fitments, container) => {
    if (!Array.isArray(fitments) || !container) return;

    const selected = vehicleKey.trim();
    const combos = fitments.map(s => s.trim());
    const hasUniversal = combos.includes("Universal");
    const hasMatch = combos.includes(selected);
    if (hasUniversal && !hasMatch) return;

    const badge = `
    <span style="position:relative;display:inline-block;width:20px;height:20px;margin-right:0.3em;">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512" height="20" style="width:auto;">
        <path fill="#212121" d="M280 32c-13.3 0-24 10.7-24 24s10.7 24 24 24l57.7 0 16.4 30.3L256 192l-45.3-45.3c-12-12-28.3-18.7-45.3-18.7L64 128c-17.7 0-32 14.3-32 32l0 32 96 0c88.4 0 160 71.6 160 160c0 11-1.1 21.7-3.2 32l70.4 0c-2.1-10.3-3.2-21-3.2-32c0-52.2 25-98.6 63.7-127.8l15.4 28.6C402.4 276.3 384 312 384 352c0 70.7 57.3 128 128 128s128-57.3 128-128s-57.3-128-128-128c-13.5 0-26.5 2.1-38.7 6L418.2 128l61.8 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32l-20.4 0c-7.5 0-14.7 2.6-20.5 7.4L391.7 78.9l-14-26c-7-12.9-20.5-21-35.2-21L280 32zM462.7 311.2l28.2 52.2c6.3 11.7 20.9 16 32.5 9.7s16-20.9 9.7-32.5l-28.2-52.2c2.3-.3 4.7-.4 7.1-.4c35.3 0 64 28.7 64 64s-28.7 64-64 64s-64-28.7-64-64c0-15.5 5.5-29.7 14.7-40.8zM187.3 376c-9.5 23.5-32.5 40-59.3 40c-35.3 0-64-28.7-64-64s28.7-64 64-64c26.9 0 49.9 16.5 59.3 40l66.4 0C242.5 268.8 190.5 224 128 224C57.3 224 0 281.3 0 352s57.3 128 128 128c62.5 0 114.5-44.8 125.8-104l-66.4 0zM128 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"/>
      </svg>
      <svg viewBox="0 0 24 24" fill="white" width="10" height="10" style="position:absolute;bottom:-1px;right:-1px;background:#008000;border-radius:50%;">
        <path d="M5 13l4 4L19 7" stroke="#fff" stroke-width="2" fill="none"></path>
      </svg>
    </span>`;

    container.innerHTML = `
      <div class="product-form__inventory" style="margin-top: 0.5em; margin-bottom: 0.55em; display: flex; align-items: center;">
        ${badge}
        <div class="product-form__inventory-text h6" style="color: #008000;">
          This item <strong>fits</strong> ${selected.replace(/_/g, " ")}
        </div>
      </div>
    `;
  };

  // PDP trigger
  if (Array.isArray(window.__fitmentData__)) {
    const fitmentBox = document.getElementById("fitment-status");
    if (fitmentBox) renderPDP(window.__fitmentData__, fitmentBox);
  }

  // --- Quick View Logic: listen for modal open every time ---
const observeQuickViewOpen = () => {
  const modal = document.querySelector("#modal-quick-view");
  if (!modal) return;

  const observer = new MutationObserver(() => {
    const isOpen = getComputedStyle(modal).display !== "none";
    if (!isOpen) return;

    const jsonEl = modal.querySelector(".fitment-json");
    const box = modal.querySelector("#fitment-status");
    if (!jsonEl || !box) return;

    try {
      const parsed = JSON.parse(jsonEl.textContent);
      renderQuickView(parsed, box);
    } catch (err) {
      console.warn("❌ quick view: JSON parse error", err.message);
    }
  });

  observer.observe(modal, {
    attributes: true,
    attributeFilter: ["style", "aria-hidden"],
  });
};

// Wait for modal to exist, then attach observer
const waitForModalAndObserve = () => {
  const modal = document.querySelector("#modal-quick-view");
  if (modal) {
    observeQuickViewOpen();
  } else {
    const tempObserver = new MutationObserver(() => {
      const modalNow = document.querySelector("#modal-quick-view");
      if (modalNow) {
        tempObserver.disconnect();
        observeQuickViewOpen();
      }
    });
    tempObserver.observe(document.body, { childList: true, subtree: true });
  }
};

// Attach on DOM ready
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", waitForModalAndObserve);
} else {
  waitForModalAndObserve();
}
})();